import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  // si no se encuentra la ruta, redirigimos a "raíz" /
 {
    path: '*',
    redirect: {
      path: '/'
    }
  },
  // Rutas externas: fuera del panel, antes de que el operador inicie sesión
  {
    path: '/',
    meta: {
      esRutaPublica: true
    },
    component: () => import('@/views/VistaFueraPanel.vue'),
    // redirigir al panel si hay operador Logado
    beforeEnter: (to, from, next) => {
      if (store.getters.operadorLogado) {
        next('/panel')
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: () => import(`@/pages/Login.vue`)
      },
      {
        path: 'olvidoContrasena',
        component: () => import(`@/pages/OlvidoContrasena.vue`)
      },
      {
        path: 'recuperarContrasena',
        component: () => import(`@/pages/RecuperarContrasena.vue`)
      }      
    ]
  },
  // Rutas de panel: Una vez que el operador ha iniciado sesión
  {
    path: '/panel',
    meta: {
      name: 'Vista del panel',
    },
    component: () => import(`@/views/VistaPanel.vue`),
    // añadir las rutas de panel en el array "children":
    children: [
      {
        path: 'empresasInquilinas',
        meta: {
          atributoRolOperadorNecesario: 'empinq'
        },
        component: () => import(`@/pages/GestionEmpresasInquilinas.vue`)
      },
      {
        path: 'gestionInstalaciones',
        meta: {
          atributoRolOperadorNecesario: 'ins'
        },
        component: () => import(`@/pages/GestionInstalaciones.vue`)
      },
      {
        path: 'gestionDescuentos',
        name: 'GestionDescuentos',
        component: () => import(`@/pages/GestionDescuentos.vue`)
      },
      {
        path: 'gestionOperadores',
        meta: {
          atributoRolOperadorNecesario: 'gesope'
        },
        component: () => import(`@/pages/GestionOperadores.vue`)
      },
      {
        path: 'registroAuditoria',
        meta: {
          atributoRolOperadorNecesario: 'regaud'
        },
        component: () => import(`@/pages/RegistroAuditoria.vue`)
      },
/*      {
        path: 'parametrosConfiguracion',
        meta: {
          atributoRolOperadorNecesario: 'parcon'
        },
        component: () => import(`@/pages/GestionParametrosConfiguracion.vue`)
      },*/
      {
        path: 'descuentosVinculados',
        name: 'DescuentosVinculados',
        meta: {
          atributoRolOperadorNecesario: 'desvin'
        },
        component: () => import(`@/pages/GestionDescuentosVinculados.vue`)
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  let proximaRuta = true // true = permitir la navegacion

  // la idea es solo intervenir si hay que Redirigir o Denegar la navegacion,
  // ya que por defecto, haremos un "next()"
  if (!store.getters.operadorLogado) { // si no hay operador logado
    if (!to.matched.some(ruta => ruta.meta.esRutaPublica)) { // y a donde se dirige NO es una ruta publica (es decir, privada)
      proximaRuta = '/' // redirigimos a la pagina de Login
    }
  } else if (store.getters.operadorLogado) {
    if (to.meta.atributoRolOperadorNecesario && !store.state.operador.atributosRol.includes (to.meta.atributoRolOperadorNecesario))  {
      proximaRuta = false // el operador no tiene permiso, denegamos la navegacion
      console.log ('A dónde crees que vas?')
    }
  }

  next (proximaRuta)
});

export default router
